const BRASILIA_TIME_ZONE = "America/Sao_Paulo";
const DATE_KEY_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATE_PREFIX_REGEX = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/;

const dateKeyFormatter = new Intl.DateTimeFormat("pt-BR", {
  timeZone: BRASILIA_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

function getDatePartsFromKey(dateKey) {
  const match = String(dateKey || "").match(DATE_KEY_REGEX);
  if (!match) return null;

  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
  };
}

export function toDateKeyInBrasilia(value = new Date()) {
  if (value === null || value === undefined || value === "") return "";

  if (typeof value === "string") {
    const text = value.trim();
    const match = text.match(DATE_PREFIX_REGEX);
    if (match) return `${match[1]}-${match[2]}-${match[3]}`;
  }

  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";

  const parts = dateKeyFormatter.formatToParts(parsed);
  const year = parts.find((part) => part.type === "year")?.value;
  const month = parts.find((part) => part.type === "month")?.value;
  const day = parts.find((part) => part.type === "day")?.value;

  if (!year || !month || !day) return "";
  return `${year}-${month}-${day}`;
}

export function toDateOnlyTimestampInBrasilia(value) {
  const dateKey = toDateKeyInBrasilia(value);
  const parts = getDatePartsFromKey(dateKey);
  if (!parts) return null;

  return new Date(parts.year, parts.month - 1, parts.day).getTime();
}

export function formatDateBRInBrasilia(value, fallback = "-") {
  const dateKey = toDateKeyInBrasilia(value);
  const parts = getDatePartsFromKey(dateKey);
  if (!parts) return fallback;

  const day = String(parts.day).padStart(2, "0");
  const month = String(parts.month).padStart(2, "0");
  return `${day}/${month}/${parts.year}`;
}

